import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router";
import { GlobalContext } from "../../../context/Context";
import Style from "./style.module.css";
import Tooltip from "../../ui/tooltip";
import OprationHomePagePopup from "../v2/index-v2";

const AsideBar = () => {
  const location = useLocation();
  const [one] = useState(1);
  let { state } = useContext(GlobalContext);

  // BOTH VIDEO LOAD AT SAME TIME
  // Inside your component:
  const leftVideoRef = useRef(null);
  const [leftLoaded, setLeftLoaded] = useState(false);
  const [allReady, setAllReady] = useState(false);

  useEffect(() => {
    if (leftLoaded) {
      setAllReady(true);
    }
  }, [leftLoaded]);

  useEffect(() => {
    if (allReady) {
      const left = leftVideoRef.current;

      const playVideos = async () => {
        try {
          await left?.play();
        } catch (err) {
          console.warn("Autoplay blocked, waiting for user interaction", err);

          // fallback: wait for user click to start
          const handleUserInteraction = async () => {
            await left?.play();
            window.removeEventListener("click", handleUserInteraction);
          };
          window.addEventListener("click", handleUserInteraction);
        }
      };

      playVideos();
    }
  }, [allReady]);

  const [opration, setOpration] = useState(false);

  let dashboardRole = state?.user?.dashboardRole === "single";

  return (
    <>
      <aside>
        <div className={Style.aside_top}>
          <div
            className={`${Style.aside_userProfle} flex align-center justify-center`}
          >
            {/* <img src={`${state.basePath}/dashboard/aside_profile.png`} alt='' /> */}

            <video
              ref={leftVideoRef}
              muted
              loop
              playsInline
              preload="auto"
              poster={`${state.basePath}/aside_logo.png`}
              onLoadedData={() => setLeftLoaded(true)}
            >
              <source src={`${state.basePath}/q_logo.mp4`} type="video/mp4" />
            </video>
          </div>

          <div className={Style.aside_navBar}>
            <Tooltip
              className={`${Style.Tooltip}`}
              boxClassName={Style.TooltipBox}
              content={"Home"}
              position={"right center"}
              onMouseMove
            >
              <div className={Style.aside_navBar_items}>
                <Link
                  to={dashboardRole ? "#" : "/dashboard/overview"}
                  className={`${Style.aside_navBar_items} ${
                    location.pathname.split("/")[one] === "dashboard"
                      ? Style.active
                      : ""
                  }`}
                >
                  {/* <div className={Style.icon}>
                                    <Home />
                                </div> */}
                  <div className={Style.icon}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/home.png`}
                      width={46}
                      height={46}
                      alt={"Home"}
                    />
                  </div>

                  <div className={`${Style.icon} ${Style.iconHover}`}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/home-hover.png`}
                      width={46}
                      height={46}
                      alt={"Home"}
                    />
                  </div>
                </Link>
              </div>
            </Tooltip>
            {/* </Tooltip> */}

            <Tooltip
              className={`${Style.Tooltip}`}
              boxClassName={Style.TooltipBox}
              content={"Leads"}
              position={"right center"}
              onMouseMove
            >
              <div className={Style.aside_navBar_items}>
                <Link
                  to={dashboardRole ? "#" : `/leads/my-leads/overview`}
                  className={`${Style.aside_navBar_items} ${
                    location.pathname.split("/")[one] === "leads"
                      ? Style.active
                      : ""
                  }`}
                >
                  {/* <div className={Style.icon}>
                                    <Users />
                                </div> */}

                  <div className={Style.icon}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/leads.png`}
                      width={46}
                      height={46}
                      alt={"leads"}
                    />
                  </div>

                  <div className={`${Style.icon} ${Style.iconHover}`}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/leads-hover.png`}
                      width={46}
                      height={46}
                      alt={"leads"}
                    />
                  </div>
                </Link>
              </div>
            </Tooltip>

            <Tooltip
              className={`${Style.Tooltip}`}
              boxClassName={Style.TooltipBox}
              content={"Accounts"}
              position={"right center"}
              onMouseMove
            >
              <div className={Style.aside_navBar_items}>
                <Link
                  to={dashboardRole ? "#" : `/accounts/account/overview`}
                  className={`${Style.aside_navBar_items} ${
                    location.pathname.split("/")[one] === "accounts"
                      ? Style.active
                      : ""
                  }`}
                >
                  {/* <div className={Style.icon}>
                                    <NotebookPen />
                                </div> */}
                  <div className={Style.icon}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/accounts.png`}
                      width={46}
                      height={46}
                      alt={"accounts"}
                    />
                  </div>

                  <div className={`${Style.icon} ${Style.iconHover}`}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/accounts-hover.png`}
                      width={46}
                      height={46}
                      alt={"accounts"}
                    />
                  </div>
                </Link>
              </div>
            </Tooltip>

            <Tooltip
              className={`${Style.Tooltip}`}
              boxClassName={Style.TooltipBox}
              content={"Deals"}
              position={"right center"}
              onMouseMove
            >
              <div className={Style.aside_navBar_items}>
                <Link
                  to={dashboardRole ? "#" : `/deals/deal/overview`}
                  className={`${Style.aside_navBar_items} ${
                    location.pathname.split("/")[one] === "deals"
                      ? Style.active
                      : ""
                  }`}
                >
                  {/* <div className={Style.icon}>
                                        <Handshake />
                                    </div> */}
                  <div className={Style.icon}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/deals.png`}
                      width={46}
                      height={46}
                      alt={"deals"}
                    />
                  </div>

                  <div className={`${Style.icon} ${Style.iconHover}`}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/deals-hover.png`}
                      width={46}
                      height={46}
                      alt={"deals"}
                    />
                  </div>
                </Link>
              </div>
            </Tooltip>

            <Tooltip
              className={`${Style.Tooltip}`}
              boxClassName={Style.TooltipBox}
              content={"Logs"}
              position={"right center"}
              onMouseMove
            >
              <div className={Style.aside_navBar_items}>
                <Link
                  to={dashboardRole ? "#" : `/logs/log`}
                  className={`${Style.aside_navBar_items} ${
                    location.pathname.split("/")[one] === "logs"
                      ? Style.active
                      : ""
                  }`}
                >
                  {/* <div className={Style.icon}>
                                        <Gem />
                                    </div> */}
                  <div className={Style.icon}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/activity.png`}
                      width={46}
                      height={46}
                      alt={"Activity"}
                    />
                  </div>

                  <div className={`${Style.icon} ${Style.iconHover}`}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/activity-hover.png`}
                      width={46}
                      height={46}
                      alt={"Activity"}
                    />
                  </div>
                </Link>
              </div>
            </Tooltip>

            <Tooltip
              className={`${Style.Tooltip}`}
              boxClassName={Style.TooltipBox}
              content={"Activities"}
              position={"right center"}
              onMouseMove
            >
              <div className={Style.aside_navBar_items}>
                <Link
                  to={dashboardRole ? "#" : `/activites/activity/overview`}
                  className={`${Style.aside_navBar_items} ${
                    location.pathname.split("/")[one] === "activites"
                      ? Style.active
                      : ""
                  }`}
                >
                  {/* <div className={Style.icon}>
                                        <FolderKanban />
                                    </div> */}
                  <div className={Style.icon}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/followup.png`}
                      width={46}
                      height={46}
                      alt={"Follow Up"}
                    />
                  </div>

                  <div className={`${Style.icon} ${Style.iconHover}`}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/followup-hover.png`}
                      width={46}
                      height={46}
                      alt={"Follow Up"}
                    />
                  </div>
                </Link>
              </div>
            </Tooltip>

            <Tooltip
              className={`${Style.Tooltip}`}
              boxClassName={Style.TooltipBox}
              content={"Projects"}
              position={"right center"}
              onMouseMove
            >
              <div className={Style.aside_navBar_items}>
                <Link
                  to={dashboardRole ? "#" : `/projects/project`}
                  className={`${Style.aside_navBar_items} ${
                    location.pathname.split("/")[one] === "projects"
                      ? Style.active
                      : ""
                  }`}
                >
                  <div className={Style.icon}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/projects.png`}
                      width={46}
                      height={46}
                      alt={"projects"}
                    />
                  </div>

                  <div className={`${Style.icon} ${Style.iconHover}`}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/projects-hover.png`}
                      width={46}
                      height={46}
                      alt={"projects"}
                    />
                  </div>
                </Link>
              </div>
            </Tooltip>

            <Tooltip
              className={`${Style.Tooltip}`}
              boxClassName={Style.TooltipBox}
              content={"Sales"}
              position={"right center"}
              onMouseMove
            >
              <div className={Style.aside_navBar_items}>
                <Link
                  to={dashboardRole ? "#" : `/sales/sale/overview`}
                  className={`${Style.aside_navBar_items} ${
                    location.pathname.split("/")[one] === "sales"
                      ? Style.active
                      : ""
                  }`}
                >
                  {/* <div className={Style.icon}>
                                        <FolderKanban />
                                    </div> */}
                  <div className={Style.icon}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/followup.png`}
                      width={46}
                      height={46}
                      alt={"Sale"}
                    />
                  </div>

                  <div className={`${Style.icon} ${Style.iconHover}`}>
                    <img
                      src={`${state.basePath}/dashboard/aside/png/followup-hover.png`}
                      width={46}
                      height={46}
                      alt={"Sale"}
                    />
                  </div>
                </Link>
              </div>
            </Tooltip>

            {/* <Tooltip className={`${Style.Tooltip}`} boxClassName={Style.TooltipBox} content={"Logs"} position={'right center'}>
                            <div className={Style.aside_navBar_items}>
                                <Link to={`/brands/brand`} className={`${Style.aside_navBar_items} ${(location.pathname.split("/")[one] === "brands") ? Style.active : ""}`}>
                                    <div className={Style.icon}>
                                        <Gem />
                                    </div>
                                </Link>
                            </div>
                        </Tooltip> */}
          </div>
        </div>

        {/* <div className={Style.aside_bottom}>
                    <div className={Style.aside_navBar}> */}
        {/* {
                            asideNav2?.map((ele, idx) => {
                                if (!ele?.role?.includes(state?.user?.user_role)) {
                                    return (<></>);
                                } else {
                                    return (
                                        <Tooltip key={`${idx}-asideBottomItems`} className={`${Style.Tooltip}`} boxClassName={Style.TooltipBox} content={ele?.name} position={'right center'}>
                                            <Link
                                                to={ele?.url}
                                                className={`${Style.aside_navBar_items} ${(location.pathname.split("/")[one] === ele?.activeKey) ? Style.active : ""}`}
                                                onClick={(e) => {
                                                    if (!ele?.url) {
                                                        e.preventDefault(); // prevent navigation
                                                        return;
                                                    }
                                                }}
                                            >
                                                <div className={Style.icon}>
                                                    {ele?.icon}
                                                </div>
                                            </Link>
                                        </Tooltip>
                                    )
                                }
                            })
                        } */}
        {/* </div>
                </div> */}
        {
          state?.user?.user_type == "6" || state?.user?.user_type == "5" ? (
            <div className={Style.aside_bottom}>
              <div className={Style.aside_bottom_navBar}>
                <Tooltip
                  className={`${Style.Tooltip}`}
                  boxClassName={Style.TooltipBox}
                  content={"Operations"}
                  position={"right center"}
                  onMouseMove
                >
                  <button
                    onClick={() => {
                      setOpration(true);
                    }}
                    className={`${Style.asideBottom_navBar_items} ${
                      opration ? Style.active : ""
                    } `}
                  >
                    <div className={`${Style.icon}`}>
                      <img
                        src={`${state.basePath}/dashboard/aside/png/reports.png`}
                        width={46}
                        height={46}
                        alt={"reports"}
                      />
                    </div>

                    <div className={`${Style.icon} ${Style.iconHover}`}>
                      <img
                        src={`${state.basePath}/dashboard/aside/png/reports-hover.png`}
                        width={46}
                        height={46}
                        alt={"user"}
                      />
                    </div>
                  </button>
                </Tooltip>
              </div>

            </div>
          ) : null
        }
      </aside>

      {opration && (
        <OprationHomePagePopup
          onClosed={() => {
            setTimeout(() => {
              setOpration(false);
            }, 200);
          }}
        />
      )}
    </>
  );
};

export default AsideBar;
